import { FEATURE_FLAGS, isFlagEnabled } from '@/utils/flagsmith';

export function getTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    return undefined;
  }
}

export function getTimezoneConfig() {
  const isTimezoneConsistencyEnabled = isFlagEnabled(FEATURE_FLAGS.int_multitimezone);

  return {
    zone: isTimezoneConsistencyEnabled ? undefined : 'utc',
    setZone: isTimezoneConsistencyEnabled ? undefined : 'utc',
    zoneOptions: isTimezoneConsistencyEnabled ? {} : { zone: 'utc' },
    shouldSendTimezoneHeader: isTimezoneConsistencyEnabled,
    isEnabled: isTimezoneConsistencyEnabled
  };
}
